import { SortOrder } from 'antd/es/table/interface';
import { RawRangeType, EnhancedFilterValue } from './types';

export const paginationSizeOptions = [10, 25, 50, 100];

export const isRawRangeType = (value: EnhancedFilterValue): value is RawRangeType => {
  return typeof value === 'object' && !Array.isArray(value) && value !== null;
};

export const isSortOrder = (value: string | string[] | null): value is SortOrder => {
  return value === 'ascend' || value === 'descend';
};
